module.exports = __webpack_public_path__ + "static/media/hip-adduction.e1ab9f3b.svg";